import Base from 'app/collections/base';
import { appUrl } from 'utils/wrappers';
import CarrierType from 'app/models/carrier_type';

export default Base.extend({
  model: CarrierType,
  url: appUrl('carrier_types'),
  comparator: 'readable',

  filtered() {
    if (this.nameFilter) {
      const term = this.nameFilter.toLowerCase();

      return this.models.filter(model => (
        model.get('readable').toLowerCase().indexOf(term) > -1
      ));
    }

    return this.models;
  },
});



// WEBPACK FOOTER //
// ./app/collections/carrier_types.js